import moment from "moment";
import { isPeriodInEffectiveRanges } from "./isPeriodInEffectiveRanges";

export function truncateSeasonPeriodsToEffectiveRange(season, effectiveRanges, useFederalScopeOverride) {
	const matchingRanges = effectiveRanges.filter(r => r.Scope === season.Scope || (!!useFederalScopeOverride && season.Scope === "FED"));

	const periods = season.Periods.filter(p => isPeriodInEffectiveRanges(p, matchingRanges, season.Scope, useFederalScopeOverride));

	for(const matchingRange of matchingRanges) {
		const begin = new Date(matchingRange.Start);
		const end = new Date(matchingRange.End);

		const beginStraddlingPeriodIndex = periods.findIndex(p => (new Date(p.BeginInclusive) < begin) && ((new Date(p.EndExclusive) > begin)));
		const endStraddlingPeriodIndex = periods.findIndex(p => (new Date(p.BeginInclusive) < end) && ((new Date(p.EndExclusive) > end)));

		if(beginStraddlingPeriodIndex > -1) {
			periods[beginStraddlingPeriodIndex] = {
				...periods[beginStraddlingPeriodIndex],
				BeginInclusive: matchingRange.Start,
				beginInclusiveMoment: moment(matchingRange.Start),
				openRange: moment.range(matchingRange.Start, periods[beginStraddlingPeriodIndex].EndExclusive)
			};
		}

		if(endStraddlingPeriodIndex > -1) {
			periods[endStraddlingPeriodIndex] = {
				...periods[endStraddlingPeriodIndex],
				EndExclusive: matchingRange.End,
				endExclusiveMoment: moment(matchingRange.End),
				openRange: moment.range(periods[endStraddlingPeriodIndex].BeginInclusive, matchingRange.End)
			};
		}
	}

	return periods;
}

export function truncateReportPeriodToEffectiveRange(period, seasonScope, effectiveRanges, useFederalScopeOverride) {
	const matchingRanges = effectiveRanges.filter(r => r.Scope === seasonScope || (!!useFederalScopeOverride && seasonScope === "FED"));
	const rangeForPeriod = matchingRanges.find(r => isPeriodInEffectiveRanges(period, [r], seasonScope, useFederalScopeOverride));
	if(rangeForPeriod === undefined) {
		return undefined;
	}

	const rangeBegin = new Date(rangeForPeriod.Start);
	const rangeEnd = new Date(rangeForPeriod.End);
	
	const needsTruncatedStart = (new Date(period.BeginInclusive) < rangeBegin) && (new Date(period.EndExclusive) > rangeBegin);
	const needsTruncatedEnd = (new Date(period.BeginInclusive) < rangeEnd) && ((new Date(period.EndExclusive) > rangeEnd));

	if(needsTruncatedStart) {
		period = {
			...period,
			BeginInclusive: rangeForPeriod.Start
		};
	}

	if(needsTruncatedEnd) {
		period = {
			...period,
			EndExclusive: rangeForPeriod.End
		};
	}

	return period;
}